import React from "react";
import style from "./../style.module.css";
import classnames from "classnames";
import { ErrorText, RichTextInput } from "ui/pages/TemplatePreview/widgets";
import { Checkbox, FormControlLabel, OutlinedInput } from "@material-ui/core";
import { ABOUT_YOU_CONFIG } from "ui/pages/TemplatePreview/constants.js";
import { convertStringToHtml } from "ui/pages/SalesPages/utils";
import { template_field_keys } from "ui/pages/TemplatePreview/constants";
import { useCreateAboutYouHandlers } from "./AboutYou/utils/useHandleAboutYou";
import { ABOUT_YOU_LABELS } from "../sidebar.constant";

export const AboutSection = ({
  disableAllEdits,
  state,
  setField,
  errorState,
  setErrorMessage,
  enableError,
  hiddenFields,
}) => {
  const { social_info, about_section_title } = template_field_keys;

  const { handleExpandCheckbox } = useCreateAboutYouHandlers({
    state,
    setField,
    setErrorMessage,
    enableError,
    hiddenFields,
  });

  return (
    <div>
      <div className={classnames("mt-3", "mb-1")}>
        <div className={`${style.label}`}>
          What would like to call this section?
        </div>
        <div className={style.field}>
          <OutlinedInput
            className={style.input}
            defaultValue="About Us"
            value={state?.social_info?.about_section_title}
            name={about_section_title.name}
            disabled={disableAllEdits}
            inputProps={{ maxLength: ABOUT_YOU_CONFIG.MAX_NAME_LENGTH }}
            onChange={(e) => {
              const inputVal = e.target.value || "";
              setField([social_info.name, about_section_title.name], inputVal);

              if (inputVal.length >= ABOUT_YOU_CONFIG.MAX_NAME_LENGTH) {
                enableError(about_section_title.name);
                setErrorMessage(
                  about_section_title.name,
                  `Maximum field length of ${ABOUT_YOU_CONFIG.MAX_NAME_LENGTH} reached.`
                );
                return;
              }
              setErrorMessage(about_section_title.name, null);
            }}
            onBlur={() => {
              enableError(about_section_title.name);
              if (state?.social_info?.about_section_title) {
                setField(
                  [social_info.name, about_section_title.name],
                  state?.social_info?.about_section_title?.trim()
                );
              }
            }}
          />
          <ErrorText
            errorState={errorState}
            fieldKey={about_section_title.name}
          />
        </div>
      </div>
      <div className={style.fieldContainer}>
        <div className={style.label}>Description</div>
        <div className={style.field}>
          <RichTextInput
            value={convertStringToHtml({
              stringToConvert: state?.bio_text || "",
            })}
            onChange={(t) => {
              setField("bio_text", t);
            }}
            readOnly={disableAllEdits}
          />
        </div>
      </div>

      <div className="tw-mt-2">
        <FormControlLabel
          control={
            <Checkbox
              checked={!!state?.lead_keys?.expand_host_desc}
              onChange={handleExpandCheckbox}
              disabled={disableAllEdits}
              color="primary"
            />
          }
          label={ABOUT_YOU_LABELS.READ_MORE_CLOSED}
        />
      </div>
    </div>
  );
};
